export const SPECIAL_INTERESTS_URL = '/special-interests';
export const SPECIAL_INTERESTS_PAGE_TITLE = 'EDIT MY SPECIAL INTERESTS';
export const SPECIAL_INTERESTS_DESCRIPTION = "We'd love to learn more about you. This will help us send you offers and information that you are interested in.";
export const SUBMIT_BUTTON = 'SUBMIT';
export const SPECIAL_INTERESTS_SUCCESSFUL_MESSAGE = 'Saved.';